import { useIntl } from "react-intl";
import { ReactNode } from "react";

interface Props {
  translationKey: string;
  value: ReactNode;
}

const TableMobileRow = ({ translationKey, value }: Props) => {
  const intl = useIntl();

  return (
    <div className="table-mobile-accordion__key-value">
      <div className="table-mobile-accordion__key">
        {intl.formatMessage({ id: translationKey })}
      </div>
      <div className="table-mobile-accordion__value">{value}</div>
    </div>
  );
};

export default TableMobileRow;
